import React from 'react';
import './styles/customer-notes.scss';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import Placeholder from '../Placeholder';
import {customerNotes, customerNoteForm} from '../../ducks/index';
import {Form, Control} from 'react-redux-form';
import {compose} from 'redux';
import {requiresSuperAdmin} from "hocs/requiresUser";

class CustomerNote extends React.Component {
  static KEY = 'customer_notes';

  // userName is passed in from the view and represents the user updating the note and their status
  // loadStatus is just the meta data around whether the object has loaded
  // customerNote is all the properties of the note we're interacting with
  static propTypes = {
    userName: PropTypes.string,
    loadStatus: PropTypes.array,
    customerNote: PropTypes.object
  };

  static defaultProps = {
    isSuperAdmin: false,
  };

  constructor(props) {
    super(props);
    this.onSave = this.onSave.bind(this);
  }

  static mapStateToProps = (state) => {
    return {
      ...state.customerNoteForm,
      pageNotes: customerNotes.all(state, CustomerNote.KEY)
    }
  };

  componentDidMount() {
    const {dispatch, pageName, pageNotes} = this.props;
    if (!pageNotes.length) {
      dispatch(customerNotes.actions.load({page_name: pageName}, CustomerNote.KEY))
        .then(response => customerNotes.actions.denormalizeObjects(response))
        .then(notes => dispatch(customerNoteForm.actions.load(notes[0])));
    }
  }

  render() {
    const {pageNotes, model} = this.props;

    return (
      <Placeholder.loading ready={pageNotes.ready}>
        <Form model="customerNoteForm.model" onSubmit={this.onSave} className='customer-note-form'>
          <Control.textarea model=".note" id="customerNoteForm.note" name="note" className='customer-note-textarea'
                            placeholder="Please write a note here..."/>
          <button type="submit" className="btn btn-primary customer-note-btn">Save Note</button>
          <div className='customer-note-last-edited'>Last edited by {model.last_updated_by}</div>
        </Form>
      </Placeholder.loading>)
  }

  onSave(){
    const {dispatch, model, userName} = this.props;
    dispatch(customerNoteForm.actions.save({...model, last_updated_by: userName}))
      .then(Utility.successMessage('Note saved!'));
  }
}

export default compose(
  requiresSuperAdmin,
  connect(CustomerNote.mapStateToProps),
)(CustomerNote);
